import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { channelsSelector } from 'common/selectors/channels';
import { withRouter } from 'react-router-dom';
import { SimpleDropDown, SimpleDropDownElement } from 'components/simple-dropdown/index';
import { useTranslation } from 'react-i18next';
import { markVideoForDeletionAction } from 'pages/my-videos.page/index';
import { showDialogAction } from 'components/redux-dialog/actions';
import { DELETE_MY_VIDEO_DIALOG } from 'pages/my-videos.page/fragments/delete-my-video-dialog';
import { MarkUnmarkStartHomeVideoDecorated } from 'components/mark-unmark-start-home-video/index';
import { viewRangeSelector } from 'common/selectors';
import { isMobileView } from 'utils';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';

const mapStateToProps = (state) => ({
  channels: channelsSelector(state),
  viewRange: viewRangeSelector(state),
});

const mapDispatchToProps = (dispatch, props) => ({
  editVideo: () => props.history.push(`/my-videos/edit/${props.video.id}`),
  deleteVideo: () => {
    dispatch(markVideoForDeletionAction(props.video.id));
    dispatch(showDialogAction(DELETE_MY_VIDEO_DIALOG));
  },
});

const ActionsContextMenu = ({ video, editVideo, deleteVideo, isItem, viewRange }) => {
  const { t } = useTranslation();

  return (
    <SimpleDropDown
      icon={faEllipsisV}
      className={isItem ? 'ct-video-list__context-menu' : ''}
      aria-label={t('video-actions-menu')}
    >
      <SimpleDropDownElement onClick={() => editVideo(video.id)}>
        <FontAwesomeIcon icon={faPencil} /> {t('edit')}
      </SimpleDropDownElement>
      <SimpleDropDownElement onClick={() => deleteVideo(video.id)}>
        <FontAwesomeIcon icon={faTrash} /> {t('delete')}
      </SimpleDropDownElement>
      {!isMobileView(viewRange) && <MarkUnmarkStartHomeVideoDecorated video={video} />}
    </SimpleDropDown>
  );
};

export const ActionsContextMenuDecorated = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ActionsContextMenu);

ActionsContextMenuDecorated.propTypes = {
  video: PropTypes.object.isRequired,
  isItem: PropTypes.bool,
};
